function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "assets/icons/ic_white_warning",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("rect", {
  id: "bounds",
  x: 0,
  y: 0,
  width: 48,
  height: 28
}), React.createElement("rect", {
  id: "background",
  fill: "#F9F9F9",
  x: 0,
  y: 0,
  width: 48,
  height: 28,
  rx: 14
}), React.createElement("g", {
  id: "assets/icons/ic_not_tested-copy",
  transform: "translate(4.000000, 2.000000)"
}, React.createElement("rect", {
  id: "bounds",
  x: 0,
  y: 0,
  width: 40,
  height: 24
}), React.createElement("path", {
  d: "M18.8760055,3.65220961 C19.2208391,3.04025203 20.0035589,2.81976775 20.6242592,3.15974418 C20.7921574,3.25170714 20.9364777,3.37928058 21.0471871,3.53257277 L21.1237602,3.65220961 L29.8379736,19.1168577 C30.1828071,19.7288153 29.9591729,20.5005103 29.3384726,20.8404867 C29.1856754,20.9241784 29.0175878,20.9760519 28.8445967,20.9934536 L28.7140963,21 L11.2856695,21 C10.5756138,21 10,20.4324938 10,19.7324395 C10,19.5601078 10.0356371,19.3900505 10.1042199,19.232508 L10.1617922,19.1168577 L18.8760055,3.65220961 Z M19.9998829,4.94329502 L11.8506429,19.4038127 L28.1481705,19.4038127 L19.9998829,4.94329502 Z M20,16 C20.5522847,16 21,16.4477153 21,17 C21,17.5522847 20.5522847,18 20,18 C19.4477153,18 19,17.5522847 19,17 C19,16.4477153 19.4477153,16 20,16 Z M19.9648821,10 C20.4977852,10 20.9298015,10.4319789 20.9298477,10.964882 L20.930148,14.4317361 C20.9301887,14.9387289 20.5577193,15.3565957 20.0778479,15.4137171 L19.9652942,15.4203426 C19.4324045,15.4203426 19.0004121,14.9777284 19.0004121,14.4317361 L19.0000897,10.964882 C19.0000437,10.470102 19.3724544,10.0622773 19.8522778,10.0065013 L19.9648821,10 Z",
  id: "Shape",
  fill: "#ffcc00"
})));

const SvgIcGrayBadgeWarning = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "48px",
    height: "28px",
    viewBox: "0 0 48 28",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgIcGrayBadgeWarning, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_gray_badge_warning.08c600eb.svg";
export { ForwardRef as ReactComponent };